import React, { useEffect, useState, useRef, useMemo  } from 'react';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import autumn from '../../assets/homeHeroBannerVideos/autumn.mp4';
import spring from '../../assets/homeHeroBannerVideos/spring.mp4';
import summer from '../../assets/homeHeroBannerVideos/summer.mp4';
import winter from '../../assets/homeHeroBannerVideos/winter.mp4';
// Mobile Videos
import autumnMobile from '../../assets/homeHeroBannerVideos/autumn-mobile.mp4';
import springMobile from '../../assets/homeHeroBannerVideos/spring-mobile.mp4';
import summerMobile from '../../assets/homeHeroBannerVideos/summer-mobile.mp4';
import winterMobile from '../../assets/homeHeroBannerVideos/winter-mobile.mp4';

import { ReactComponent as Mute } from '../../assets/svgs/sound-on.svg';
import { ReactComponent as Unmute } from '../../assets/svgs/sound-off.svg';
import { ReactComponent as Pause } from '../../assets/svgs/pause.svg';
import { ReactComponent as Play } from '../../assets/svgs/play.svg';
import { ReactComponent as MapSVG } from '../../assets/svgs/minimap.svg';


// Greek Desktop
import autumnGreek from '../../assets/homeHeroBannerVideos/autumnGreek.mp4';
import winterGreek from '../../assets/homeHeroBannerVideos/winterGreek.mp4';
import springGreek from '../../assets/homeHeroBannerVideos/springGreek.mp4';
import summerGreek from '../../assets/homeHeroBannerVideos/summerGreek.mp4';

// Greek Mobile
import autumnGreekMobile from '../../assets/homeHeroBannerVideos/autumn-mobile-greek.mp4';
import winterGreekMobile from '../../assets/homeHeroBannerVideos/winter-mobile-greek.mp4';
import springGreekMobile from '../../assets/homeHeroBannerVideos/spring-mobile-greek.mp4';
import summerGreekMobile from '../../assets/homeHeroBannerVideos/summer-mobile-greek.mp4';



// Media query hook
const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return isMobile;
};

// // Dynamic season data
// const getSeasonVideos = (isMobile) => [
//   {
//     title: 'autumn',
//     videos: [isMobile ? autumnMobile : autumn],
//     labels: [
//       { text: 'Autumn Vibes' },
//       { text: 'Local Villages' },
//       { text: 'Outdoor activities' },
//       { text: 'Churches' },
//     ],
//   },
//   {
//     title: 'winter',
//     videos: [isMobile ? winterMobile : winter],
//     labels: [
//       { text: 'Winter Wonderland' },
//       { text: 'Snowy Dreams' },
//     ],
//   },
//   {
//     title: 'spring',
//     videos: [isMobile ? springMobile : spring],
//     labels: [
//       { text: 'Theater with views' },
//       { text: 'Monuments' },
//     ],
//   },
//   {
//     title: 'summer',
//     videos: [isMobile ? summerMobile : summer],
//     labels: [
//       { text: 'Platamonas Castle' },
//       { text: 'Beautiful beaches' },
//       { text: 'Water sports' },
//       { text: 'Relaxation' },
//     ],
//   },
// ];


const getSeasonVideos = (isMobile, language) => [
  {
    title: 'autumn',
    videos: [
      language === 'gr'
        ? (isMobile ? autumnGreekMobile : autumnGreek)
        : (isMobile ? autumnMobile : autumn)
    ],
    labels: [
      { text: language === 'gr' ? 'Φθινοπωρινή Ατμόσφαιρα' : 'Autumn Vibes' },
      { text: language === 'gr' ? 'Τοπικά Χωριά' : 'Local Villages' },
      { text: language === 'gr' ? 'Εξωτερικές Δραστηριότητες' : 'Outdoor activities' },
      { text: language === 'gr' ? 'Εκκλησίες' : 'Churches' },
    ],
  },
  {
    title: 'winter',
    videos: [
      language === 'gr'
        ? (isMobile ? winterGreekMobile : winterGreek)
        : (isMobile ? winterMobile : winter)
    ],
    labels: [
      { text: language === 'gr' ? 'Χειμωνιάτικο Τοπίο' : 'Winter Wonderland' },
      { text: language === 'gr' ? 'Χιονισμένα Όνειρα' : 'Snowy Dreams' },
    ],
  },
  {
    title: 'spring',
    videos: [
      language === 'gr'
        ? (isMobile ? springGreekMobile : springGreek)
        : (isMobile ? springMobile : spring)
    ],
    labels: [
      { text: language === 'gr' ? 'Θέατρο με Θέα' : 'Theater with views' },
      { text: language === 'gr' ? 'Μνημεία' : 'Monuments' },
    ],
  },
  {
    title: 'summer',
    videos: [
      language === 'gr'
        ? (isMobile ? summerGreekMobile : summerGreek)
        : (isMobile ? summerMobile : summer)
    ],
    labels: [
      { text: language === 'gr' ? 'Κάστρο Πλαταμώνα' : 'Platamonas Castle' },
      { text: language === 'gr' ? 'Όμορφες Παραλίες' : 'Beautiful beaches' },
      { text: language === 'gr' ? 'Θαλάσσια Σπορ' : 'Water sports' },
      { text: language === 'gr' ? 'Χαλάρωση' : 'Relaxation' },
    ],
  },
];



const Container = styled.div`
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
`;

const CarouselContainer = styled.div`
  position: relative;
  width: 100%;
  height: 90vh;
  background-size: cover;
  background-position: center;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  z-index: 0;
  overflow: hidden;
`;

const BackgroundVideo = styled.video`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: -1;
  filter: brightness(0.8);
`;

const LabelsModal = styled.div`
  position: absolute;
  top: 15%;
  left: 5%;
  background-color: rgba(0, 0, 0, 0.1);
  color: white;
  padding: 10px 15px;
  border-radius: 10px;
  font-size: 13px;
  z-index: 3;
  display: flex;
  flex-direction: column;
  gap: 3px;
  opacity: 0;
  animation: slideInFromLeftToRight 2s ease-out forwards;

  @keyframes slideInFromLeftToRight {
    0% {
      opacity: 0;
      transform: translateX(-10%);
    }
    100% {
      opacity: 1;
      transform: translateX(0);
    }
  }

  @media (max-width: 768px) {
    left: 50%;
    transform: translateX(-50%);
    top: 15%;
    padding: 8px 12px;
    gap: 6px;
    text-align: center;
    background-color: transparent;
  }
`;

const SeasonButtons = styled.div`
  position: absolute;
  bottom: 50px;
  right: 180px;
  display: flex;
  gap: 20px;
  margin-right: 10px;
  border-radius: 10px;
  padding: 10px 20px;
  z-index: 1;

  @media (max-width: 768px) {
    left: 50%;
    transform: translateX(-50%);
    right: auto;
    bottom: 80px;
    padding: 8px 12px;
    gap: 6px;
  }
`;

const SeasonButton = styled.button`
  cursor: pointer;
  border: none;
  background-color: transparent;
  font-size: 12px;
  font-weight: 400;
  color: white;
  letter-spacing: 1px;
  padding-bottom: 4px;
  border-bottom: 2px solid transparent;
  transition: all 0.3s ease;

  &.active {
    font-size: 16px;
    border-bottom: 2px solid white;
    border-radius: 2px;
  }
`;

const MuteButton = styled.button`
  position: absolute;
  bottom: 55px;
  right: 20px;
  cursor: pointer;
  border: none;
  background-color: transparent;
  color: white;
  padding: 10px 20px;
  border-radius: 10px;
  z-index: 1;

  @media (max-width: 768px) {
    width: 40px;
    bottom: 20px;
    left: 55%;
    transform: translateX(-50%);
    padding: 8px 12px;
  }
`;

const PlayPauseButton = styled.button`
  position: absolute;
  bottom: 55px;
  right: 70px;
  cursor: pointer;
  border: none;
  background-color: transparent;
  color: white;
  padding: 10px 20px;
  border-radius: 10px;
  z-index: 1;

  @media (max-width: 768px) {
    width: 40px;
    bottom: 20px;
    left: 45%;
    transform: translateX(-50%);
    padding: 8px 12px;
  }
`;

const MapContainer = styled.div`
  position: absolute;
  bottom: 20px;
  left: 50px;
  cursor: pointer;
  border: none;
  color: white;
  padding: 10px 20px;
  border-radius: 10px;
  z-index: 1;

  @media (max-width: 768px) {
    display: none;
  }
`;

const HomeImage = () => {
  const { i18n } = useTranslation();
  const isMobile = useIsMobile();
  const language = sessionStorage.getItem("selectedLanguage") || "en";
  // const seasons = useMemo(() => getSeasonVideos(isMobile), [isMobile]);
  const seasons = useMemo(() => getSeasonVideos(isMobile, language), [isMobile, language]);

  // const [selectedSeason, setSelectedSeason] = useState(seasons[0]);
  const [videoIndex, setVideoIndex] = useState(0);
  const [isMuted, setIsMuted] = useState(true);
  const [isPlaying, setIsPlaying] = useState(true);
  const [animationKey, setAnimationKey] = useState(0);
  const videoRef = useRef(null);

  const getCurrentSeason = () => {
  const month = new Date().getMonth() + 1; // 0-indexed!
  if (month >= 3 && month <= 5) return 'spring';
  if (month >= 6 && month <= 8) return 'summer';
  if (month >= 9 && month <= 11) return 'autumn';
  return 'winter'; // Dec-Jan-Feb
};

  const [selectedSeason, setSelectedSeason] = useState(() => {
  const current = getCurrentSeason();
  const match = seasons.find(s => s.title === current);
  return match || seasons[0];
});


  // Sync selected season when switching mobile/desktop
  // useEffect(() => {
  //   const updatedSeason = seasons.find(season => season.title === selectedSeason.title);
   
  //   if (updatedSeason) {
    
  //     setSelectedSeason(updatedSeason);
  //     setVideoIndex(0); // Reset to first video in updated season
  //   }
  //   else {
  //   console.warn('⚠️ No matching season found for:', selectedSeason.title);
  // }
  // }, [isMobile, seasons]);

useEffect(() => {
  const updatedSeason = seasons.find(season => season.title === selectedSeason.title);
  if (updatedSeason) {
    setSelectedSeason(updatedSeason);
    setVideoIndex(0);
  }
}, [isMobile, language, seasons]);


  useEffect(() => {
    const interval = setInterval(() => {
      setVideoIndex((prevIndex) => (prevIndex + 1) % selectedSeason.videos.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [selectedSeason]);

  useEffect(() => {
    setAnimationKey((prevKey) => prevKey + 1);
  }, [selectedSeason, videoIndex]);

  const handleMuteToggle = () => setIsMuted(prev => !prev);

  const handlePlayPauseToggle = () => {
    const video = videoRef.current;
    if (video) {
      isPlaying ? video.pause() : video.play();
      setIsPlaying(prev => !prev);
    }
  };

  return (
    <Container>
      <CarouselContainer>
        <BackgroundVideo
          ref={videoRef}
          key={`${selectedSeason.title}-${videoIndex}-${animationKey}`}
          autoPlay
          loop
          muted={isMuted}
          playsInline
        >
          <source src={selectedSeason.videos[videoIndex]} type="video/mp4" />
          Your browser does not support the video tag.
        </BackgroundVideo>

        {/* <MapContainer>
          <MapSVG height={180} width={180} />
        </MapContainer> */}

        <SeasonButtons>
          {seasons.map((season, index) => (
            <SeasonButton
              key={index}
              onClick={() => {
                setSelectedSeason(season);
                setVideoIndex(0);
                setIsPlaying(true);
              }}
              className={selectedSeason.title === season.title ? 'active' : ''}
            >
              {i18n.t(season.title)}
            </SeasonButton>
          ))}
        </SeasonButtons>

        <MuteButton onClick={handleMuteToggle}>
          {isMuted ? <Unmute height={20} width={20} /> : <Mute height={20} width={20} />}
        </MuteButton>

        <PlayPauseButton onClick={handlePlayPauseToggle}>
          {isPlaying ? <Pause height={20} width={20} /> : <Play height={20} width={20} />}
        </PlayPauseButton>
      </CarouselContainer>
    </Container>
  );
};

export default HomeImage;




